import { BUILDING_ENERGY, ROOF_MATERIAL } from '~/lib/graphql/types';
import type { QuestionItem } from '~/lib/store/types';

const questionsCommercialMy: QuestionItem[] = [
    {
        slug: 'roof-type',
        type: 'select',
        label: 'My rooftop type is...',
        input: 'roof',
        value: ROOF_MATERIAL.METAL,
        validated: true,
        option: [
            {
                label: 'Metal roof',
                type: 'option',
                value: ROOF_MATERIAL.METAL,
                asset: { path: '/metal_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            },
            {
                label: 'Concrete roof',
                type: 'option',
                value: ROOF_MATERIAL.CONCRETE,
                asset: { path: '/concrete_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            },
            {
                label: 'Tile roof',
                type: 'option',
                value: ROOF_MATERIAL.TILES,
                asset: {
                    path: '/simple_tiled_roof.png',
                    width: 56,
                    height: 48
                },
                input: 'roof'
            },
            {
                label: "I'm not sure / mixed roof",
                type: 'option',
                value: ROOF_MATERIAL.OTHER,
                asset: { path: '/unknown_roof.png', width: 56.15, height: 48 },
                input: 'roof'
            }
        ]
    },
    {
        slug: 'storeys',
        label: 'The number of storeys in my property is...',
        input: 'storeys',
        type: 'number',
        value: '1',
        validated: true
    },
    {
        slug: 'electricity-bill',
        type: 'select',
        label: 'My monthly electricity bill is...',
        input: 'bill',
        value: 'true',
        validated: true,
        option: [
            {
                label: 'I know my estimated monthly bill',
                input: 'bill',
                type: 'option',
                value: 'true',
                nestedQuestion: {
                    label: '',
                    input: 'utilities',
                    type: 'currency',
                    value: '',
                    billHintValues: [2000, 3000, 4000, 5000]
                }
            },
            {
                label: "I don't know my monthly electricity bill",
                input: 'bill',
                type: 'option',
                value: 'false',
                nestedQuestion: {
                    label: 'Please select the following options.',
                    input: 'energy',
                    type: 'choice',
                    value: '',
                    option: [
                        {
                            label: 'Non intensive consumption',
                            type: 'option',
                            value: BUILDING_ENERGY.LOW,
                            input: 'energy',
                            description:
                                'Eg. Warehouses, sports complex, community clubs, etc.'
                        },
                        {
                            label: 'Average consumption',
                            type: 'option',
                            value: BUILDING_ENERGY.AVERAGE,
                            input: 'energy',
                            description: 'Eg. Offices, apartments, hotels, etc.'
                        },
                        {
                            label: 'Intensive consumption',
                            type: 'option',
                            value: BUILDING_ENERGY.INTENSIVE,
                            input: 'energy',
                            description:
                                'Eg. Shopping malls, hospitals, universities, industrial plants, etc.'
                        }
                    ]
                }
            }
        ]
    },
    {
        slug: 'operating-hours',
        label: "My business's operating hours are...",
        type: 'select',
        input: 'dayTimeConsumption',
        value: 'WEEKDAY_OFFICE',
        validated: true,
        option: [
            {
                label: 'Weekdays, office hours (8am to 6pm)',
                type: 'option',
                value: 'WEEKDAY_OFFICE',
                input: 'dayTimeConsumption'
            },
            {
                label: 'Weekdays, extended hours (7am to 11pm)',
                type: 'option',
                value: 'WEEKDAY_OFFICE_EXTENDED',
                input: 'dayTimeConsumption'
            },
            {
                label: 'Everyday, office hours (8am to 6pm)',
                type: 'option',
                value: 'EVERYDAY_OFFICE',
                input: 'dayTimeConsumption'
            },
            {
                label: 'Everyday, extended hours (7am to 11pm)',
                type: 'option',
                value: 'EVERYDAY_OFFICE_EXTENDED',
                input: 'dayTimeConsumption'
            },
            {
                label: '24/7',
                type: 'option',
                value: 'TWENTYFOUR_SEVEN',
                input: 'dayTimeConsumption'
            },
            {
                label: 'Others',
                type: 'option',
                value: 'OTHER',
                input: 'dayTimeConsumption'
            }
        ]
    }
];

export default questionsCommercialMy;
